import React, { useState } from 'react';
import InputForm from '../../../InputT';
import SearInputM from '../../../SearchModal';
//import "../../Assets/Styles/StyleForm.css";
import Params from '../../../../Types/ParamsPicklist';
import { Box, CircularProgress, TextField, Typography } from '@mui/material';
import { Checkbox, Input, Radio, Spin, Table } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { CheckBox, MonetizationOn, MonetizationOnOutlined, Money, Phone, SwipeUp, TextFields } from '@mui/icons-material';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import Utilisateur from '../../../../Models/Utilisateur';
import SearchInput from '../../../SearchInput';
import CustuomTreeSelect from '../../../CustuomTreeSelect';
import RadioBox from '../../../Radiox';
import { ColumnsType } from 'antd/es/table';
import axios from 'axios';
import { Crypter } from '../../../../Functions/Security/Crypter';
import DataType from '../../../../Types/DataTablePiclist';
import Datas from '../../../../Data/Data.json'
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import SweetAlert from "sweetalert2"


let searchUser: Params = { CodeAgence: '', Table: "UTILIS", Colonne1: "CODUTI", Colonne2: "NOMUTI", Colagence: '001', Choix: 22 }


let searchTypAdr: Params = { CodeAgence: '', Table: "UTILIS", Colonne1: "CODUTI", Colonne2: "NOMUTI", Colagence: '001', Choix: 22 }



//Initialisation des parametres de recherche
let searchTitre: Params = { CodeAgence: '', Table: "TITRES", Colonne1: "CDTITR", Colonne2: "LIBELL1", Colagence: '101', Choix: 22 }
let searchSituationFamiliale: Params = { CodeAgence: "SITFAM", Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: "RUBRIQ", Choix: 22 }
let searchProspect: Params = { CodeAgence: '', Table: "DEMARC", Colonne1: "CODDMR", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchClassRisque: Params = { CodeAgence: '', Table: "CLARIS", Colonne1: "CLARIS", Colonne2: "LIBELLFR", Colagence: '101', Choix: 22 }
let searchPays: Params = { CodeAgence: '', Table: "CDPAYS", Colonne1: "CDPAYS", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchActivite: Params = { CodeAgence: '', Table: "TABNAE", Colonne1: "CODNAE", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchUniteInstitutionnel: Params = { CodeAgence: '', Table: "TABNUI", Colonne1: "CODNUI", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchRegimeMatrimonial: Params = { CodeAgence: "REGMAT", Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: "RUBRIQ", Choix: 22 }
//
let searchNiveauInstruction: Params = { CodeAgence: '', Table: "INSTRU", Colonne1: "CODINS", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchEthnie: Params = { CodeAgence: '', Table: "ETHNIE", Colonne1: "CODETH", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchCateGo: Params = { CodeAgence: '', Table: "CATEGO", Colonne1: "CATEGO", Colonne2: "LIBELLFR", Colagence: '101', Choix: 22 }
let searchZoneGeo: Params = { CodeAgence: '', Table: "RESIDE", Colonne1: "CDRESI", Colonne2: "LIBELLFR", Colagence: '101', Choix: 22 }
let searchCpt: Params = { CodeAgence: '', Table: "AGENCE", Colonne1: "plc2", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchGroup: Params = { CodeAgence: '', Table: "GROUPUSER", Colonne1: "CODGROUP", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchGes: Params = { CodeAgence: '', Table: "GESTIONNAIRE", Colonne1: "CODGES", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchService: Params = { CodeAgence: '', Table: "SERVICE", Colonne1: "CODSERV", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchIndice: Params = { CodeAgence: '', Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: '101', Choix: 22 }
let searchCompte: Params = { CodeAgence: '', Table: "CCOMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: '101', Choix: 22 }
let searchStatus: Params = { CodeAgence: '', Table: "Status", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchGroupUtilis: Params = { CodeAgence: '', Table: "GROUPUSER", Colonne1: "CODGROUP", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchPlanCpte: Params = { CodeAgence: '', Table: "V_COMPTE_CLIENTELE_PLANCP", Colonne1: "IDPLAN", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchCsion: Params = { CodeAgence: '', Table: "OPERAT", Colonne1: "CODOPE", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchMontantCsion: Params = { CodeAgence: '', Table: "OPERAT", Colonne1: "MONFIX", Colonne2: "CODOPE", Colagence: '101', Choix: 22 }


function Tab4(props: { form?: any }) {
  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))


  // USER TOKEN
  const authHeader = useAuthHeader()

  const [Data, SetData] = React.useState<DataType[]>([]);

  const [selectedRowKeys, setSelectedRowKeys] = React.useState<React.Key[]>([]);

  const onSelectChange = (newSelectedRowKeys: any) => {
    //console.log('selectedRowKeys changed: ', rowSelection);
    setSelectedRowKeys(newSelectedRowKeys);
    const d = []
    for (let j = 0; j < newSelectedRowKeys.length; j++) {
      const element = newSelectedRowKeys[j];
      //console.log(Data[element as number])
      d.push((Data[element]).Code)
    }
    //console.log(d)
    localStorage.setItem(Datas.LocalVariable.groupPlanCp, Crypter.encrypt(JSON.stringify(d)))
  };
  const [loading, setLoading] = React.useState(false);
  const [pageIsLoad, setPageIsLoad] = useState(true)
  //const [checked, setChecked] = React.useState(false);
  const [checked1, setChecked1] = React.useState(true);
  const [checked2, setChecked2] = React.useState(true);
  const [checked3, setChecked3] = React.useState(true);
  const [checked4, setChecked4] = React.useState(true);
  const [checked5, setChecked5] = React.useState(true);
  const [checked, setChecked] = React.useState(false);

  const [loadMont1, setLoadMont1] = React.useState(false);
  const [loadMont2, setLoadMont2] = React.useState(false);
  const [loadMont3, setLoadMont3] = React.useState(false);
  const [loadMont4, setLoadMont4] = React.useState(false);
  const [loadMont5, setLoadMont5] = React.useState(false);

  const tabCheck = [checked1, checked2, checked3, checked4, checked5]


  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const commissions = [
    {
      indexe: 1,
      code: "946",
      label: "CION N°1/MISE EN PLACE PRET"
    },
    {
      indexe: 2,
      code: "947",
      label: "CION N°2/MISE EN PLACE PRET"
    },
    {
      indexe: 3,
      code: "948",
      label: "CION N°3/MISE EN PLACE PRET"
    },
    {
      indexe: 4,
      code: "949",
      label: "CION N°4/MISE EN PLACE PRET"
    },
    {
      indexe: 5,
      code: "974",
      label: "CION N°5/MISE EN PLACE PRET"
    },
  ]




  if (pageIsLoad) {
    setPageIsLoad(false)

    setLoading(true);
    const datat: DataType[] = [];

    //var data = {CodeAgence:searchPlanCpte?.CodeAgence,Table:props.Parametre?.Table,Colonne1:props.Parametre?.Colonne1,Colonne2:props.Parametre?.Colonne2,Colagence:props.Parametre?.Colagence,Init:values.text,choix:props.Parametre?.Choix}

    var config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Datas.ApiUrl.AnySearch,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authHeader(),
        'CypherSearch': Crypter.encrypt(JSON.stringify(searchPlanCpte))
      }
    };
    axios(config)
      .then((response) => {
        //alert('ok')
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;

          if (res.StatutCode == 200) {
            let datas = res.Result.Table;

            if (datas.length === 0) {
              //console.log("aucun élément ");
              SetData(datat)
            }
            else {
              datas.map((data: any, indice: number) => {
                //console.log(JSON.stringify(data))
                datat.push({
                  key: indice,
                  Code: data[Object.keys(data)[1]],
                  Libelle: data[Object.keys(data)[0]],
                });
                SetData(datat);
              })
              // for(let i=0;i<=datas.length;i++)
              // {
              //   datat.push({
              //     key: i,
              //     Code: datas[i][1],
              //     Libelle: datas[i][0],
              //   });
              //   SetData(datat);  
              // }
            }
          }
        }
        setLoading(false);

      }).catch((error) => {
        console.log(error)
        setLoading(false);
        // SweetAlert.fire({title: "Error", text : error})
      })
  }


  function loadGroup() {
    try {
      let groupPlanCp = JSON.parse(Crypter.decrypt(localStorage.getItem(Datas.LocalVariable.groupPlanCp) + '') + "")
      //console.log(groupPlanCp)
      const d: any = []
      for (let i = 0; i < Data.length; i++) {
        for (let j = 0; j < groupPlanCp.length; j++) {
          //console.log(groupPlanCp[j])
          if (Data[i].Code == groupPlanCp[j].IDPLAN) {
            d.push(Data[i].key)
            //break;
          }
        }
      }
      setSelectedRowKeys(d)
      console.log(d)
    } catch (error) {
      console.log(error)
    }
  }
  setTimeout(() => {
    if (selectedRowKeys.length == 0) {
      loadGroup()
    }
    try {
      let reset = localStorage.getItem(Datas.LocalVariable.reset)
      if (reset == "1") {
        setSelectedRowKeys([])
        //localStorage.clear()
      }
    }
    catch (error) {
      console.log(error)
    }
  }, 1);

  const onChange = (cssion: any) => {
    
    let montant = props.form.getFieldValue("MONTAN");

    if (montant) {

      let indexe = cssion.indexe
    let mont = 0;
    switch (indexe) {
      case 1:
        setChecked1(!checked1)
        setLoadMont1(true);
        break;
      case 2:
        setChecked2(!checked2)
        setLoadMont2(true);
        break;
      case 3:
        setChecked3(!checked3)
        setLoadMont3(true);
        break;
      case 4:
        setChecked4(!checked4)
        setLoadMont4(true);
        break;
      case 5:
        setChecked5(!checked5)
        setLoadMont5(true);
        break;

      default:
        break;
    }

    const datat: DataType[] = [];
    var datas = { commission: null }
    var data = { CodeAgence: searchMontantCsion?.CodeAgence, Table: searchMontantCsion?.Table, Colonne1: searchMontantCsion?.Colonne1, Colonne2: searchMontantCsion?.Colonne2, Colagence: searchMontantCsion?.Colagence, Init: cssion.code, choix: searchMontantCsion?.Choix }


      var com = { "CodOpe": cssion.code, Montant: montant, "CodAge": user.codage }
      //console.log(Crypter.encrypt(JSON.stringify(data)))
      //alert(JSON.stringify(com))
      var config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Datas.ApiUrl.GetCommission,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authHeader(),
          'CypherCommission': Crypter.encrypt(JSON.stringify(com))
        }
      };
      axios(config)
        .then((response) => {
          //alert('ok')
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;

            if (res.StatutCode == 200) {
              datas = res.Result.Table[0];

              switch (indexe) {
                case 1:
                  if (!checked1) {
                    mont = props.form.getFieldValue('MTNCOM' + indexe) ? props.form.getFieldValue('MTNCOM' + indexe) : 0
                    props.form.setFieldValue('MTNCOM' + indexe, "0")
                  } else {
                    props.form.setFieldValue("MTNCOM" + indexe, datas.commission)
                  }
                  setChecked1(!checked1)
                  break;
                case 2:
                  if (!checked2) {
                    mont = props.form.getFieldValue('MTNCOM' + indexe) ? props.form.getFieldValue('MTNCOM' + indexe) : 0
                    props.form.setFieldValue('MTNCOM' + indexe, "0")
                  } else {
                    props.form.setFieldValue("MTNCOM" + indexe, datas.commission)
                  }
                  setChecked2(!checked2)
                  break;
                case 3:
                  if (!checked3) {
                    mont = props.form.getFieldValue('MTNCOM' + indexe) ? props.form.getFieldValue('MTNCOM' + indexe) : 0
                    props.form.setFieldValue('MTNCOM' + indexe, "0")
                  } else {
                    props.form.setFieldValue("MTNCOM" + indexe, datas.commission)
                  }
                  setChecked3(!checked3)
                  break;
                case 4:
                  if (!checked4) {
                    mont = props.form.getFieldValue('MTNCOM' + indexe) ? props.form.getFieldValue('MTNCOM' + indexe) : 0
                    props.form.setFieldValue('MTNCOM' + indexe, "0")
                  } else {
                    props.form.setFieldValue("MTNCOM" + indexe, datas.commission)
                  }
                  setChecked4(!checked4)
                  break;
                case 5:
                  if (!checked5) {
                    mont = props.form.getFieldValue('MTNCOM' + indexe) ? props.form.getFieldValue('MTNCOM' + indexe) : 0
                    props.form.setFieldValue('MTNCOM' + indexe, "0")
                  } else {
                    props.form.setFieldValue("MTNCOM" + indexe, datas.commission)
                  }
                  setChecked5(!checked5)
                  break;

                default:
                  break;
              }
              var montant = parseInt(props.form.getFieldValue('MTNCOM' + indexe) + "") ? parseInt(props.form.getFieldValue('MTNCOM' + indexe) + "") : 0
              var total = parseInt(props.form.getFieldValue("cssionApliq") + "") ? parseInt(props.form.getFieldValue("cssionApliq") + "") : 0


              switch (indexe) {
                case 1:
                  if (checked1) {
                    total = total + montant
                  } else {
                    total = total - mont
                  }
                  break;
                case 2:
                  if (checked2) {
                    total = total + montant
                  } else {
                    total = total - mont
                  }
                  break;
                case 3:
                  if (checked3) {
                    total = total + montant
                  } else {
                    total = total - mont
                  }
                  break;
                case 4:
                  if (checked4) {
                    total = total + montant
                  } else {
                    total = total - mont
                  }
                  break;
                case 5:
                  if (checked5) {
                    total = total + montant
                  } else {
                    total = total - mont
                  }
                  break;
                default:
                  break;
              }



              props.form.setFieldValue("cssionApliq", total)
              //SetData([{Code: datas.CODOPE, Libelle : datas.MONFIX, key: 0}])
            }
          }
          //setLoadMont1(false);

        }).catch((error) => {
          //console.log(error)
          setChecked1(true);
          setChecked2(true);
          setChecked3(true);
          setChecked4(true);
          setChecked5(true);


          SweetAlert.fire({ title: "Error", text: error, icon: "error" })
        }).finally(() => {
          switch (indexe) {
            case 1:
              setLoadMont1(false);
              break;
            case 2:
              setLoadMont2(false);
              break;
            case 3:
              setLoadMont3(false);
              break;
            case 4:
              setLoadMont4(false);
              break;
            case 5:
              setLoadMont5(false);
              break;

            default:
              break;
          }
        })
    }
    else {
      SweetAlert.fire({ title: "Veillez saisir le montant de la demande de prêt", icon: "warning" })
    }
  };
  function chekAll(e: any) {
    setChecked1(!e.target.checked)
    setChecked2(!e.target.checked)
    setChecked3(!e.target.checked)
    setChecked4(!e.target.checked)
    setChecked5(!e.target.checked)
  }

  setTimeout(() => {
    if (selectedRowKeys.length == 0) {
      loadGroup()
    }
    try {
      let reset = localStorage.getItem(Datas.LocalVariable.reset)
      if (reset == "1") {
        setChecked(false)
        setChecked1(true)
        setChecked2(true)
        setChecked3(true)
        setChecked4(true)
        setChecked5(true)
      }
      // else{
      //   for (let i = 1; i < 6; i++) {

      //     if (props.form.getFieldValue("MTNCOM"+i).length != 0 ) {
      //       if(i == 1) setChecked1(false)
      //       else if(i == 2) setChecked2(false)
      //       else if(i == 3) setChecked3(false)
      //       else if(i == 4) setChecked4(false)
      //       else setChecked5(false)
      //     }else{
      //       if(i == 1) setChecked1(true)
      //       else if(i == 2) setChecked2(true)
      //       else if(i == 3) setChecked3(true)
      //       else if(i == 4) setChecked4(true)
      //     }

      //   }
      // }
    }
    catch (error) {
      console.log(error)
    }
  }, .1);

  function change(e: any, indexe: number) {
    let value = e.target.value as number
    var t = 0
    if (value + "" == "") {
      props.form.setFieldValue("MTNCOM" + indexe, 0)
    } else {
      props.form.setFieldValue("MTNCOM" + indexe, value)
    }
    for (let i = 1; i <= commissions.length; i++) {
      var tmp = parseInt(props.form.getFieldValue("MTNCOM" + i) + "") ? parseInt(props.form.getFieldValue("MTNCOM" + i) + "") : 0
      t = t + tmp
      //console.log(t)
    }
    //alert(t)
    props.form.setFieldValue("cssionApliq", t)
  }

  return (
    <div className='tabItem'>
      <div >
        <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}>
          <Box display={"flex"} fontStyle="inherit" className='border-left'>
            <Box fontStyle="inherit" className='border-left'>

              {commissions.map((cssion, indexe) => (
                <Box marginTop={1} >
                  <Checkbox checked={!tabCheck[indexe]} onChange={() => { onChange(cssion) }}>
                    <SearInputM width={6} defaultCode={cssion.code} defaultLibelle={cssion.label} form={props.form} Titre={'Recherche Type Commission ' + (indexe + 1)} label={'Type Csion ' + (indexe + 1)} name={'CODOPE' + (indexe + 1)} Parametre={searchCsion} />
                  </Checkbox>
                </Box>
              ))}
            </Box>
            <Box fontStyle="inherit" className='border-left'>
              {/* {commissions.map((cssion, indexe)=>(
                <InputForm onChange={onChange}  disabled={checked} width={9} label={'Montant 1'} icon={loadMont? <CircularProgress color='inherit' size={20}/>: <SwipeUp color='disabled' fontSize='small'/>}   name={'MTNCOM1'}  type='number' error='mobile' />
              ))} */}

              <InputForm min={0} defaultValue='0' onChange={(e) => { change(e, 1) }} disabled={checked1} width={9} label={'Montant 1'} icon={loadMont1 ? <CircularProgress color='inherit' size={20} /> : <SwipeUp color='disabled' fontSize='small' />} name={'MTNCOM1'} type='number' error='mobile' />
              <InputForm min={0} defaultValue='0' onChange={(e) => { change(e, 2) }} disabled={checked2} width={9} label={'Montant 2'} icon={loadMont2 ? <CircularProgress color='inherit' size={20} /> : <SwipeUp color='disabled' fontSize='small' />} name={'MTNCOM2'} type='number' error='mobile' />
              <InputForm min={0} defaultValue='0' onChange={(e) => { change(e, 3) }} disabled={checked3} width={9} label={'Montant 3'} icon={loadMont3 ? <CircularProgress color='inherit' size={20} /> : <SwipeUp color='disabled' fontSize='small' />} name={'MTNCOM3'} type='number' error='mobile' />
              <InputForm min={0} defaultValue='0' onChange={(e) => { change(e, 4) }} disabled={checked4} width={9} label={'Montant 4'} icon={loadMont4 ? <CircularProgress color='inherit' size={20} /> : <SwipeUp color='disabled' fontSize='small' />} name={'MTNCOM4'} type='number' error='mobile' />
              <InputForm min={0} defaultValue='0' onChange={(e) => { change(e, 5) }} disabled={checked5} width={9} label={'Montant 5'} icon={loadMont5 ? <CircularProgress color='inherit' size={20} /> : <SwipeUp color='disabled' fontSize='small' />} name={'MTNCOM5'} type='number' error='mobile' />
            </Box>
            <Box fontStyle="inherit" className='border-left'>
              <InputForm defaultValue='0' disabled width={11} label='Csion Appliquées' icon={<SwipeUp color='disabled' fontSize='small' />} name='cssionApliq' type='text' error='mobile' />
              {/* <br /><br /><br /><br /><br /><br /><br />
                <Checkbox onClick={()=>{setChecked(!checked)}} checked={checked} onChange={chekAll}>
                  <Typography>Appliquer tous les Commissions</Typography>
                </Checkbox> */}
            </Box>
          </Box>
        </Box>
      </div>
    </div>
  )
}

export default Tab4;  
